export enum BOOKING_STATUS {
  ACTIVE = 'new',
  CANCELLED = 'canceled',
  MODIFIED = 'modified',
}
